import { render, staticRenderFns } from "./u-btn-arrow-outlined-circle.vue?vue&type=template&id=366ccc8e&scoped=true&"
import script from "./u-btn-arrow-outlined-circle.vue?vue&type=script&lang=js&"
export * from "./u-btn-arrow-outlined-circle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "366ccc8e",
  null
  
)

export default component.exports